// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner--spinner--1c1Il","graphic":"Spinner--graphic--2Qe-K","spin":"Spinner--spin--2-6Th"};